/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
import moment from 'moment';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { apiDownloadDocument } from '../../../services/axios-client/axeCommons';

function QuoteInfo({ quote }) {
    const downloadDocument = async (documentId) => {
        const response = await apiDownloadDocument(documentId);
        const alink = document.createElement('a');
        alink.target = '_blank';
        alink.href = response.data.data.contents;
        alink.download = response.data.data.filename;
        alink.click();
    };
    return (
        <div className="w-75 ms-auto mb-3">
            <div className="bg-warning p-3 rounded-3 shadow">
                <h5 className="fs-6">Infomazioni Quotazione Richiesta</h5>
                <hr />
                <div>
                    <div className="row">
                        {quote.company_name && (
                            <div className="col-6">
                                <p className="m-0">
                                    <small>
                                        <strong>
                                            Compagnia:
                                        </strong>
                                        {' '}
                                        {quote.company_name}
                                    </small>
                                </p>
                            </div>
                        )}
                        {quote.product_name && (
                            <div className="col-6">
                                <p className="m-0">
                                    <small>
                                        <strong>
                                            Prodotto:
                                        </strong>
                                        {' '}
                                        {quote.product_name}
                                    </small>
                                </p>
                            </div>
                        )}
                        {quote.vehicle_plate && (
                            <div className="col-6">
                                <p className="m-0">
                                    <small>
                                        <strong>
                                            Targa:
                                        </strong>
                                        {' '}
                                        {quote.vehicle_plate}
                                    </small>
                                </p>
                            </div>
                        )}
                        {quote.moto_plate && (
                            <div className="col-6">
                                <p className="m-0">
                                    <small>
                                        <strong>
                                            Targa:
                                        </strong>
                                        {' '}
                                        {quote.moto_plate}
                                    </small>
                                </p>
                            </div>
                        )}
                        <div className="col-6">
                            <p className="m-0">
                                <small>
                                    <strong>
                                        Numero Polizza:
                                    </strong>
                                    {' '}
                                    {quote.saved_code_id}
                                </small>
                            </p>
                        </div>
                        <div className="col-6">
                            <p className="m-0">
                                <small>
                                    <strong>Cliente:</strong>
                                    {' '}
                                    {quote.business_name ? quote.business_name : `${quote.name} ${quote.surname}`}
                                </small>
                            </p>
                        </div>
                        <div className="col-6">
                            <p className="m-0">
                                <small>
                                    <strong>Premio:</strong>

                                    {' '}
                                    {quote.amount}
                                    {' '}
                                    €
                                </small>
                            </p>
                        </div>
                        <div className="col-6">
                            <p className="m-0">
                                <small>
                                    <strong>
                                        {quote.vat_number ? 'Partita IVA' : 'Data Di Nascita'}
                                        :
                                    </strong>
                                    {' '}
                                    {quote.vat_number ? quote.vat_number : quote.date_of_birth}
                                </small>
                            </p>
                        </div>
                        <div className="col-6">
                            <p className="m-0">
                                <small>
                                    <strong>
                                        Data Decorrenza:
                                    </strong>
                                    {' '}
                                    {moment(quote.policy_effective_date).format('L')}
                                </small>
                            </p>
                        </div>
                        <div className="col-12">
                            <p className="m-0">
                                <small>
                                    <strong>
                                        Frequenza Pagamento:
                                    </strong>
                                    {' '}
                                    {quote.payment_frequency === 1 ? 'Annuale' : 'Semestrale'}
                                </small>
                            </p>
                        </div>
                        {quote.document && (
                            <div className="mt-3">
                                <button
                                  className="border-0 btn btn-success"
                                  onClick={() => downloadDocument(quote?.document?.id)}
                                >
                                    <FontAwesomeIcon icon={faDownload} className="me-1" />
                                    Scarica Polizze
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default QuoteInfo;
